export default "__VITE_ASSET__CYoCXvih__"